import { Controller } from "@hotwired/stimulus"

// Falls back to an initials-circle when the avatar <img> fails to load
// (LinkedIn CDN URLs can expire). CSP-safe replacement for inline onerror.
export default class extends Controller {
  static values = { initials: String, color: String, size: Number }

  connect() {
    const img = this.element
    // If the image already failed to load before Stimulus connected,
    // `error` won't fire again — detect via .complete + naturalWidth.
    if (img.complete && img.naturalWidth === 0) {
      this.replaceWithFallback()
      return
    }
    img.addEventListener("error", () => this.replaceWithFallback(), { once: true })
  }

  replaceWithFallback() {
    const fallback = document.createElement("div")
    const size = this.sizeValue || 40
    fallback.className = "rounded-full flex items-center justify-center font-semibold text-slate-600 flex-shrink-0"
    fallback.style.cssText = `background:${this.colorValue};width:${size}px;height:${size}px;font-size:${size <= 32 ? '0.75rem' : '0.875rem'}`
    fallback.textContent = this.initialsValue
    this.element.replaceWith(fallback)
  }
}
